import React from "react";
import { graphql } from "gatsby";
import Layout from "../../../components/Layout";
import StandardBanner from "../../../components/StandardHero/StandardHero";
import VideoFeaturePanel from "../../../components/VideoFeaturePanel/VideoFeaturePanel";
import RelatedServices from "../../../components/RelatedServices/RelatedServices";
import ImageCopyPanel from "../../../components/ImageCopyPanel";
import HubspotFormV2 from "../../../components/HubspotFormV2/HubspotFormV2";
import SubBanner from "../../../components/SubBanner/SubBanner";
import EnhancedBenefits from "../../../components/EnhancedBenefits/EnhancedBenefits";
import AdditionalResources from "../../../components/AddtionalResources/AdditionalResources";
import Modal from "react-responsive-modal";

const modalStyles = require("../../../styles/formModal.module.scss");

const AmxZero = ({
  data: {
    banner,
    banner: {
      contactForm,
      RequestCallbackForm,
      howItWorksForm,
      videoPanel,
      detailPanel,
      enhancedBenefits: enhancedBenefitsData,
      additionalResourceHeading,
      additional_resources: additionalResourceData,
      services: relatedServicesData,
      Articles: articlesData,
      topics,
      client_types,
      filter_types,
    },
  },
}) => {
  const bannerImage =
    banner.hero.image.localFile.childImageSharp.gatsbyImageData;
  const bannerTitle = banner.hero.title;
  const showBreadcrumb = banner.hero.showBreadcrumb;

  const subBanner = {
    image: banner.subBanner.image.localFile.publicURL,
    heading: banner.subBanner.heading,
    cta1: banner.subBanner.cta1 || null,
    cta2: banner.subBanner.cta2 || null,
  };

  const breadcrumbs = [{ name: "WHAT WE DO" }, { name: "AMX ZERO" }];

  const [openModal1, setOpenModal1] = React.useState(false);
  const [openModal2, setOpenModal2] = React.useState(false);
  const [openModal3, setOpenModal3] = React.useState(false);

  const cta1Click = () => {
    setOpenModal1(true);
  };

  const cta2Click = () => {
    setOpenModal2(true);
  };

  const cta3Click = () => {
    setOpenModal3(true);
  };

  return (
    <Layout
      seo={{
        title: banner.metaData?.pageTitle,
        description: banner.metaData?.metadescription,
        image: bannerImage,
      }}
    >
      <StandardBanner
        image={bannerImage}
        title={bannerTitle}
        showBreadcrumb={showBreadcrumb}
        breadcrumbs={breadcrumbs}
      />
      <SubBanner
        image={subBanner.image}
        heading={subBanner.heading}
        cta1={
          subBanner.cta1
            ? {
                cta: subBanner.cta1,
                icon: subBanner.cta1.icon.localFile.publicURL,
                handleOnClick: cta1Click,
                bkgColor: "blackOnBlack",
              }
            : null
        }
        cta2={
          subBanner.cta2
            ? {
                cta: subBanner.cta2,
                icon: subBanner.cta2.icon.localFile.publicURL,
                handleOnClick: cta2Click,
                bkgColor: "whiteOnBlack",
              }
            : null
        }
      />
      <VideoFeaturePanel
        layout="reverseColMobile"
        data={videoPanel}
        buttonClick={() => cta2Click()}
      />
      <EnhancedBenefits
        enhancedBenefitsData={enhancedBenefitsData}
        buttonClick={() => cta1Click()}
      />
      <ImageCopyPanel panel={detailPanel} buttonClick={() => cta3Click()} />

      {additionalResourceData.length ? (
        <AdditionalResources
          items={additionalResourceData}
          heading={additionalResourceHeading}
        />
      ) : null}

      <RelatedServices
        relatedServicesData={relatedServicesData}
        articlesData={articlesData}
        tagTypes={filter_types}
        topics={topics}
        client_types={client_types}
      />
      <Modal
        open={openModal3}
        onClose={() => setOpenModal3(false)}
        center
        classNames={{
          overlay: "customOverlay",
          modal: modalStyles.formModal,
          closeIcon: modalStyles.formCloseIcon,
          closeButton: modalStyles.formCloseButton,
        }}
      >
        <>
          <HubspotFormV2
            formId={contactForm.hubspotCode}
            recaptureId="contact-form"
            title={contactForm.heading}
            alwaysConsent={true}
            isPopup={true}
            titleDescription={contactForm.mainCopy}
            confirmationMessage={contactForm.confirmationCopy}
            submitButton={{
              bkgColor: "blackOnLight",
            }}
            selectStyles={{
              option: (provided) => ({
                ...provided,
                color: "black",
              }),
              placeholder: (provided) => ({
                ...provided,
                color: "#2d2d2d",
                opacity: 0.4,
              }),
              singleValue: (provided) => ({
                ...provided,
                color: "#2d2d2d",
              }),
              valueContainer: (provided) => ({
                ...provided,
                color: "#2d2d2d",
                height: "50px",
              }),
              control: (provided, state) => ({
                ...provided,
                backgroundColor: "transparent",
                border: "1px solid #2d2d2d",
                width: "100%",
                color: "white",
                borderRadius: "0",
                marginBottom: "10px",
              }),
            }}
          />
        </>
      </Modal>
      <Modal
        open={openModal1}
        onClose={() => setOpenModal1(false)}
        center
        classNames={{
          overlay: "customOverlay",
          modal: modalStyles.formModal,
          closeIcon: modalStyles.formCloseIcon,
          closeButton: modalStyles.formCloseButton,
        }}
      >
        <>
          <HubspotFormV2
            formId={howItWorksForm.hubspotCode}
            recaptureId="how-it-works"
            title={howItWorksForm.heading}
            alwaysConsent={true}
            isPopup={true}
            titleDescription={howItWorksForm.mainCopy}
            confirmationMessage={howItWorksForm.confirmationCopy}
            submitButton={{
              bkgColor: "blackOnLight",
            }}
            selectStyles={{
              option: (provided) => ({
                ...provided,
                color: "black",
              }),
              placeholder: (provided) => ({
                ...provided,
                color: "#2d2d2d",
                opacity: 0.4,
              }),
              singleValue: (provided) => ({
                ...provided,
                color: "#2d2d2d",
              }),
              valueContainer: (provided) => ({
                ...provided,
                color: "#2d2d2d",
                height: "50px",
              }),
              control: (provided, state) => ({
                ...provided,
                backgroundColor: "transparent",
                border: "1px solid #2d2d2d",
                width: "100%",
                color: "white",
                borderRadius: "0",
                marginBottom: "10px",
              }),
            }}
          />
        </>
      </Modal>
      <Modal
        open={openModal2}
        onClose={() => setOpenModal2(false)}
        center
        classNames={{
          overlay: "customOverlay",
          modal: modalStyles.formModal,
          closeIcon: modalStyles.formCloseIcon,
          closeButton: modalStyles.formCloseButton,
        }}
      >
        <>
          <HubspotFormV2
            formId={RequestCallbackForm.hubspotCode}
            recaptureId="request-callback"
            title={RequestCallbackForm.heading}
            isPopup={true}
            alwaysConsent={true}
            titleDescription={RequestCallbackForm.mainCopy}
            confirmationMessage={RequestCallbackForm.confirmationCopy}
            submitButton={{
              bkgColor: "blackOnLight",
            }}
            selectStyles={{
              option: (provided) => ({
                ...provided,
                color: "black",
              }),
              placeholder: (provided) => ({
                ...provided,
                color: "#2d2d2d",
                opacity: 0.4,
              }),
              singleValue: (provided) => ({
                ...provided,
                color: "#2d2d2d",
              }),
              valueContainer: (provided) => ({
                ...provided,
                color: "#2d2d2d",
                height: "50px",
              }),
              control: (provided, state) => ({
                ...provided,
                backgroundColor: "transparent",
                border: "1px solid #2d2d2d",
                width: "100%",
                color: "white",
                borderRadius: "0",
                marginBottom: "10px",
              }),
            }}
          />
        </>
      </Modal>
    </Layout>
  );
};

export default AmxZero;

export const query = graphql`
  {
    banner: strapiAmxZero {
      topics {
        id
        type
      }
      client_types {
        id
        Type
      }
      filter_types {
        type
      }
      hero {
        image {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        showBreadcrumb
      }
      metaData {
        pageTitle
        metadescription
      }
      faqLink {
        faq_category {
          category
        }
        text
      }
      Articles {
        articlesHeading
        insights {
          id
        }
        case_studies {
          id
        }
        press_releases {
          id
        }
        events {
          id
        }
      }
      services {
        shortDesc
        Image {
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                webpOptions: { quality: 100 }
                placeholder: TRACED_SVG
              )
            }
          }
          alternativeText
        }
      }

      subBanner {
        heading
        image {
          id
          localFile {
            publicURL
          }
        }
        cta1 {
          link
          text
          icon {
            localFile {
              publicURL
            }
          }
        }
        cta2 {
          link
          text
          icon {
            localFile {
              publicURL
            }
          }
        }
      }
      enhancedBenefits {
        benefits {
          Title
          Copy
          Icon {
            alternativeText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  quality: 100
                  webpOptions: { quality: 100 }
                  placeholder: TRACED_SVG
                )
              }
            }
          }
        }
        intro
        cta {
          link
          text
          icon {
            localFile {
              publicURL
            }
          }
        }
      }

      additionalResourceHeading

      additional_resources {
        copy
        title
        form {
          confirmationCopy
          heading
          hubspotCode
          mainCopy
        }
        image {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        iconCta {
          id
          text
          icon {
            localFile {
              publicURL
            }
          }
        }
      }

      detailPanel {
        copy
        colorTheme
        imagePosition
        image {
          localFile {
            publicURL
          }
          alternativeText
        }
        cta {
          link
          text
          icon {
            localFile {
              publicURL
            }
          }
        }
      }

      contactForm {
        confirmationCopy
        mainCopy
        heading
        hubspotCode
      }
      howItWorksForm {
        confirmationCopy
        heading
        hubspotCode
        mainCopy
      }

      RequestCallbackForm {
        confirmationCopy
        heading
        hubspotCode
        mainCopy
      }
      videoPanel {
        copy
        cta {
          link
          text
          icon {
            localFile {
              publicURL
            }
          }
        }
        cta2 {
          link
          text
          icon {
            localFile {
              publicURL
            }
          }
        }
        video {
          video {
            localFile {
              publicURL
            }
          }
          transcript {
            localFile {
              id
              publicURL
            }
          }
        }

        mainImage {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`;
